import React from 'react';

const Diferencial = () => {
  const diferenciales = [
    {
      text: 'Somos profesionales que trabajamos de manera conjunta con los clientes, para entablar lazos de confianza y asi lograr resultados eficientes con compromiso y responsabilidad.'
    },
    {
      text: 'Nuetro equipo de trabajo se capacita continuamente para mantener un nivel de asesoramiento que se ajuste a los cambios normativos y legales actuales.'
    },
    {
      text: 'La experiencia adquirida en los años de trayectoria nos permite entender no solo la realidad económica de tu negocio sino también las oportunidades de crecimiento.'
    }
  ];

  return (
    <section className="py-16 sm:py-24" style={{ backgroundColor: 'rgba(55, 153, 196, 0.09)' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Text Column */}
          <div className="space-y-8 mr-5 ml-5">
            <h2 className="text-3xl sm:text-4xl font-bold text-primary text-center lg:text-left">
              Nuestro diferencial
            </h2>
            {diferenciales.map((item, index) => (
              <div key={index} className="flex gap-4 items-start">
                <div className="flex-shrink-0 mt-1">
                  {/* Check icon SVG */}
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="16" fill="#3799C4"/>
                    <path d="M13.472 19.2721L22.241 10.503C22.448 10.2961 22.6894 10.1926 22.9653 10.1926C23.2412 10.1926 23.4827 10.2961 23.6896 10.503C23.8965 10.71 24 10.9559 24 11.2408C24 11.5257 23.8965 11.7712 23.6896 11.9775L14.1962 21.4967C13.9893 21.7036 13.7479 21.8071 13.472 21.8071C13.196 21.8071 12.9546 21.7036 12.7477 21.4967L8.29847 17.0475C8.09153 16.8406 7.9922 16.595 8.00048 16.3108C8.00876 16.0266 8.11671 15.7807 8.32434 15.5731C8.53197 15.3654 8.77788 15.262 9.06208 15.2626C9.34627 15.2633 9.59184 15.3668 9.79878 15.5731L13.472 19.2721Z" fill="white"/>
                  </svg>
                </div>
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          {/* Image Column */}
          <div>
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img 
                src="/images/2.jpeg" 
                alt="Equipo profesional SP Asociados" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Diferencial;
